/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
function o(n) {
  const t = { horizontal: "left", vertical: "bottom" };
  return n && (t.horizontal = "right"), t;
}
function i(n) {
  const t = { horizontal: "left", vertical: "top" };
  return n && (t.horizontal = "right"), t;
}
export {
  o as getAnchorAlign,
  i as getPopupAlign
};
